import { PERMISSION_ACCESS_ADMIN } from "../models/Permission";

export const BLOCK_FEATURE_ON_MOBILE_PERMISSIONS = [PERMISSION_ACCESS_ADMIN];
